import { render } from "./EditProductEntitlement.vue?vue&type=template&id=49fc91d7"
import script from "./EditProductEntitlement.vue?vue&type=script&lang=js"
export * from "./EditProductEntitlement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__